import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";


// ✅ Load Platform Settings
export async function loadPlatformSettingsApi() {
  try {
    const fd = new FormData();

    const res = await axios.post(`${apiBaseUrl}adminsetapis/get_settings`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch {
    return { status: false };
  }
}

export async function loadRecoveryApi(page) {
  try {

    const fd = new FormData();
    fd.append("page", page);

    const res = await axios.post(
      `${apiBaseUrl}adminapis/getRecoveryRequests`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch (err) {
    return {
      status: false,
      type: "danger",
      success: "Failed to load recovery requests"
    };
  }
}

export async function updateRecoveryApi(data) {
  try {

    const fd = new FormData();

    fd.append("rec_id", data.rec_id);
    fd.append("status", data.status);

    const res = await axios.post(
      `${apiBaseUrl}adminapis/updateRecoveryStatus`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch (err) {
    return {
      status: false,
      type: "danger",
      success: "Failed to update recovery request"
    };
  }
}


// ✅ Save Platform Settings
export async function savePlatformSettingsApi(payload) {
  try {
    const fd = new FormData();

    fd.append("maintenance", payload.maintenance || "");
    fd.append("creatorSignup", payload.creatorSignup || "");
    fd.append("fanOpenSignup", payload.fanOpenSignup || "");

    fd.append("manualCreators", payload.manualCreators || "");
    fd.append("autoSocial", payload.autoSocial || "");

    fd.append("dailyLimit", payload.dailyLimit || "");
    fd.append("minAudience", payload.minAudience || "");

    fd.append("blockDisposable", payload.blockDisposable || "");

    fd.append("by", payload.by || "");

    const res = await axios.post(`${apiBaseUrl}adminsetapis/save_settings`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch {
    return { status: false };
  }
}
